import { Header } from "@/components/sections/header";
import { Hero } from "@/components/sections/hero";
import { Problem } from "@/components/sections/problem";
import { HowItWorks } from "@/components/sections/how-it-works";
import { Capabilities } from "@/components/sections/capabilities";
import { ReadinessPreview } from "@/components/sections/readiness-preview";
import { JurisdictionCoverage } from "@/components/sections/jurisdiction-coverage";
import { WebsitePrivacyConsent } from "@/components/sections/website-privacy-consent";
import { PricingModel } from "@/components/sections/pricing-model";
import { DataMinimization } from "@/components/sections/data-minimization";
import { Trust } from "@/components/sections/trust";
import { FAQ } from "@/components/sections/faq";
import { FinalCTA } from "@/components/sections/final-cta";
import { Footer } from "@/components/sections/footer";
import { BackToTop } from "@/components/ui/back-to-top";

function App() {
  return (
    <>
      <Header />
      <main id="main-content">
        <Hero />
        <Problem />
        <HowItWorks />
        <Capabilities />
        <ReadinessPreview />
        <JurisdictionCoverage />
        <WebsitePrivacyConsent />
        <PricingModel />
        <DataMinimization />
        <Trust />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}

export default App;
